/**
 * The product's ONE phone display convention.
 *
 * Promoted VERBATIM from `client/src/pages/GenericCategoryPage.tsx:640` at s205, unchanged in
 * behaviour. It lived in a page file and was not exported, so the 25 `phone`-typed template fields
 * followed it and nothing else could — and the contact card, which is now the one place a phone
 * number gets captured for a person, was a plain text box that ignored it.
 *
 * 🔴 WHAT IT DELIBERATELY DOES NOT DO, so nobody "fixes" it later:
 *   • it does not validate, and it rejects nothing;
 *   • it does not strip characters a planner typed;
 *   • a non-`+1` international number is returned UNTOUCHED — we do not know that country's format
 *     and inventing one would be worse than leaving theirs alone;
 *   • any other length is returned UNTOUCHED rather than mangled into a shape it does not fit.
 *
 * Those four are the design. A planner's number is theirs; this only tidies the two shapes we can
 * be certain about.
 */
export function formatPhone(raw: string): string {
  if (!raw) return raw;
  const trimmed = raw.trim();
  // International non-+1: preserve as-is
  if (trimmed.startsWith("+") && !trimmed.startsWith("+1")) return trimmed;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === "1") return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return trimmed; // don't mangle non-standard lengths
}
